import { useCallback, useMemo } from "react";

import { RouterProvider } from "@tanstack/react-router";
import { Flex, Spin } from "antd";

import {
	AuthGuardProvider,
	AuthWrapper,
	isPbmPortalClient,
	useDefinition,
	useNeuClient,
	useSchemaWorker,
} from "@neu/libui";

import { TwoFAVerify } from "#components/TwoFAVerify";

import { ForgotPassword, Login, ResetPassword } from "#components";

import { ChatPushSync } from "./ChatPushSync";
import styles from "./bootstrap.module.scss";
import { HOMEBASE_GUARDS } from "./guards";
import { pbmPortalRouter } from "./pbm-portal-route-table";
import { router } from "./route-table";
import schemaWorkerURL from "../workers/schemaTransformer.worker.ts?worker&url";

function AuthenticatedApp() {
	const { data: rawDefinitions, isLoading } = useDefinition();
	const onLoad = useCallback(() => {}, []);
	const neuClient = useNeuClient();
	const isPbmPortal = isPbmPortalClient(neuClient);

	const activeRouter = useMemo(
		() => (isPbmPortal ? pbmPortalRouter : router),
		[isPbmPortal]
	);

	useSchemaWorker(rawDefinitions, {
		workerURL: schemaWorkerURL,
	});

	return (
		<AuthGuardProvider guards={HOMEBASE_GUARDS} onLoad={onLoad}>
			{!isPbmPortal && <ChatPushSync />}
			{isLoading ? (
				<Flex
					justify="center"
					align="center"
					className={styles.loading}
				>
					<Spin size="large" tip="Loading..." />
				</Flex>
			) : (
				<RouterProvider key={neuClient} router={activeRouter} />
			)}
		</AuthGuardProvider>
	);
}

export function Bootstrap() {
	return (
		<AuthWrapper
			LoginComponent={Login}
			TwoFAComponent={TwoFAVerify}
			ForgotPasswordComponent={ForgotPassword}
			ResetPasswordComponent={ResetPassword}
		>
			<AuthenticatedApp />
		</AuthWrapper>
	);
}
